// src/components/DemonCard.js
import React, { useEffect, useRef } from "react";
import "./DemonCard.css";

const STAT_COLORS = {
  colere:  { color: "#c0392b", label: "COLÈRE" },
  destruct:{ color: "#e67e22", label: "DESTRUCTION" },
  tcho:    { color: "#d4a017", label: "TCHO" },
  matos:   { color: "#7ecec4", label: "MATOS" },
  violence:{ color: "#b07fe8", label: "VIOLENCE" },
};

const PERK_LABELS = {
  illegal_serve:"Illegal Serve", cheater:"Cheater", lucky_edge:"Lucky Edge & Nets",
  no_backend:"No Backend", sweater_guy:"Sweater Guy", tennis_guy:"Tennis Guy",
  slapper:"Slapper", excuse_guy:"Excuse Guy", equipment_junky:"Equipment Junky",
  diving_guy:"Diving Guy", too_many_man:"Too Many Manierisms", ball_breaker:"Ball Breaker",
  screamer:"Screamer", rager:"Rager", high_toss:"High Toss", perfect_no_tac:"Perfect Tech No Tactic",
  trick_shot:"Trick Shot", old_monkey:"Old Monkey Tactics", defender:"Defender",
  attacker:"Attacker", spinner:"Spinner", looper:"Looper", fisher:"Fisher",
};

export default function DemonCard({ demon, compact = false }) {
  const { oni, stats, perks } = demon;
  const chaos = stats.chaos || 30;
  const animated = useRef(false);
  const cardRef = useRef();

  useEffect(() => {
    if (!cardRef.current || animated.current) return;
    const observer = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        animated.current = true;
        // Trigger CSS transitions by adding a class
        cardRef.current?.classList.add("animate-in");
        observer.disconnect();
      }
    }, { threshold: 0.2 });
    observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`demon-card${compact ? " compact" : ""}`} ref={cardRef}>
      <div className="demon-card-glow" />

      <div className="demon-header">
        <div className="demon-avatar-wrap">
          <div className="demon-avatar">{oni.emoji}</div>
        </div>
        <div className="demon-identity">
          <span className="demon-jp">{oni.jp}</span>
          <h2 className="demon-en">{oni.name.toUpperCase()}</h2>
          <span className="badge badge-blood" style={{ marginTop: "0.5rem" }}>
            {oni.name}
          </span>
        </div>
      </div>

      {!compact && (
        <p className="demon-desc">{oni.desc}</p>
      )}

      {/* Lawful / Chaos axis */}
      <div className="axis-block">
        <div className="axis-labels">
          <span>⚖ LAWFUL</span>
          <span>CHAOS ☠</span>
        </div>
        <div className="axis-track">
          <div className="axis-fill" style={{ width: chaos + "%" }} />
          <div className="axis-pip" style={{ left: `calc(${chaos}% - 4px)` }} />
        </div>
      </div>

      {/* Stats */}
      <div className="stats-block">
        {Object.entries(STAT_COLORS).map(([key, { color, label }]) => (
          <div className="stat-row" key={key}>
            <span className="stat-label">{label}</span>
            <div className="stat-track">
              <div
                className="stat-fill"
                style={{ width: (stats[key] || 0) + "%", background: color }}
              />
            </div>
            <span className="stat-val" style={{ color }}>{stats[key] || 0}</span>
          </div>
        ))}
      </div>

      {/* Perks */}
      {perks && perks.length > 0 && !compact && (
        <div className="perks-block">
          <p className="block-title">PERKS DÉMONIAQUES</p>
          <div className="perks-tags">
            {perks.map(p => (
              <span key={p} className="perk-tag">⚡ {PERK_LABELS[p] || p}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
